<template>
  <ubi-panel style="background-color: #EBF3F2;">
    <ubi-search-container
        :filters="filters"
        v-on:resetfilter="doFilter('reset')"
        v-on:filter="doFilter($event)"
        :defaultFilter="this.filter.preset"
        :more-opened="filter.advanced"
        @update:more-opened="advanced => setFilterAdvanced({ advanced })"
    >
      <el-row :gutter="20">
        <el-col :lg="10" v-if="nbStocks > 1">
          <el-form-item :label="$t('general.filters.stockSelection')">
            <el-select
                v-model="filter.stock"
                :placeholder="$t('general.filters.stockSelectionPlaceholder')"
                clearable
            >
              <el-option
                  v-for="stock in stocks"
                  :key="stock.id"
                  :label="upperCase(stock.nom)"
                  :value="stock.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12">
          <!-- Search field -->
          <el-form-item no-help :label="$t('general.filters.openSearch')">
            <el-input
                type="text"
                :value="filter.search"
                @input="setSearch"
                :placeholder="$t('general.filters.openSearchPlaceholder')"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- Recherche sur type d'annonce pour bailleurs sociaux -->
        <el-col :lg="24" style="padding-left: 10px; padding-right: 10px;padding-top:10px;"
                v-if="isBailleurSocial && !filter.annonceParente">
          <el-form-item :label="$t('posts.postType')" prop="typeObjet">
            <el-radio-group :value="filter.typeObjets" @input="typeObjets => addFilter({ typeObjets })">
              <el-radio label="1000">{{
                  $t("posts.immoAncien") }}
              </el-radio>
              <el-radio label="3000">{{
                  $t("posts.newPrograms") }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :lg="12" style="padding-left: 10px; padding-right: 10px;padding-top:10px;"
                v-if="!isPromoteur && !isCmi && !(isBailleurSocial && (filter.typeObjets == 3000 || filter.typeObjets == null))">
          <el-form-item v-if="!isPromoteur || (isBailleurSocial && filter.typeObjets == 1000) || !isBailleurSocial" no-help :label="$t('general.filters.offerType')">
            <el-select
                v-model="filter.offerTypes"
                @input="offerType => addFilter({ offerType })"
                :placeholder="$t('general.filters.offerTypePlaceholder')"
                clearable
                filterable
                multiple
                reserve-keyword
            >
              <el-option
                  v-for="offerType in getOfferTypes"
                  :key="offerType.code"
                  :label="upperCase(offerType.libelle)"
                  :value="offerType.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" style="padding-left: 10px; padding-right: 10px;padding-top:10px;" v-if="!(isBailleurSocial && (filter.typeObjets == 3000 || filter.typeObjets == null))">
          <!-- Objects types -->
          <PostFilterObjectType v-if="isPromoteur && !filter.annonceParente" :min-level="3"
                                :label="$t('general.filters.programType')"
                                style="margin-top: -10px"></PostFilterObjectType>
          <PostFilterObjectType v-else-if="isPromoteur && filter.annonceParente" :isLot="true"
                                :min-level="4"></PostFilterObjectType>
          <PostFilterObjectType v-else-if="isBailleurSocial && !filter.annonceParente" :isLot="false"
                                :min-level="4"></PostFilterObjectType>
          <el-form-item v-else-if="isCmi && $route.name != 'content-library'" label="Type de bien" prop="typeObjet">
            <el-radio label="all" v-model="filter.typeObjets" value="all">{{
                $t("general.filters.all") }}
            </el-radio>
            <el-radio label="1300" v-model="filter.typeObjets" value="1310">{{
                $t("posts.buildingLandTitle") }}
            </el-radio>
            <el-radio label="5200" v-model="filter.typeObjets" value="5200">{{
                $t("general.filters.programTypeLandHouse") }}
            </el-radio>
          </el-form-item>
          <el-form-item v-else-if="isCmi && $route.name == 'content-library'" label="Type de bien" prop="typeObjet">
            <el-radio label="all" v-model="filter.typeObjets" value="all">{{
                $t("general.filters.all") }}
            </el-radio><br/>
            <el-radio label="1300" v-model="filter.typeObjets" value="1300">{{
                $t("general.filters.programTypeLand") }}
            </el-radio><br/>
            <el-radio label="1200" v-model="filter.typeObjets" value="1200">{{
                $t("general.filters.models") }}
            </el-radio><br/>
            <el-radio label="5200" v-model="filter.typeObjets" value="5200">{{
                $t("general.filters.typeLandHouse") }}
            </el-radio>

          </el-form-item>
          <PostFilterObjectType v-else :min-level="2"
                                :label="$t('general.filters.propertyType')"></PostFilterObjectType>
        </el-col>
      </el-row>

      <template v-slot:more v-if="$route.name != 'content-library'">
        <el-row style="background-color: #EBF3F2; margin-top: 10px;">
          <el-col :lg="12" v-if="!isPromoteur && !(isBailleurSocial && (filter.typeObjets == 3000 || filter.annonceParente))">
            <el-form-item :label="$t('general.filters.mandateType')">
              <el-radio-group
                  :value="filter.mandates"
                  @input="mandates => addFilter({ mandates })"
              >
                <el-radio @click="filter.mandates = null">{{
                    $t("general.filters.mandateTypeAll") }}
                </el-radio>
                <el-radio value="simple" label="simple">{{
                    $t("general.filters.mandateTypeSimple") }}
                </el-radio>
                <el-radio value="exclusif" label="exclusif">
                  {{
                    $t("general.filters.mandateTypeExclusive")
                  }}
                </el-radio>
                <el-radio value="semi-exclusif" label="semi-exclusif">
                  {{
                    $t("general.filters.mandateTypeSemiExclusive")
                  }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :lg="12">
            <el-form-item :label="$t('general.filters.dateCreation')">
              <el-date-picker
                  type="daterange"
                  :value="filter.dateCreationGt || filter.dateCreationLt? [
                        filter.dateCreationGt || undefined,
                        filter.dateCreationLt || undefined
                      ] : null"
                  :start-placeholder="$t('general.filters.dateCreationStart')"
                  :end-placeholder="$t('general.filters.dateCreationEnd')"
                  @input="
                        dates => addFilter({ dateCreationGt: dates? dates[0] : null, dateCreationLt: dates ? dates[1] : null})
                      "
                  format="dd/MM/yyyy"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30" style="background-color: #EBF3F2;">
          <el-col :lg="8">
            <el-form-item
                :label="$t('general.filters.surface', { surfaceGt: filter.surfaceGt, surfaceLt: filter.surfaceLt })">
              <ubi-slider
                  :min="0"
                  :max="1000"
                  range
                  :format-tooltip="value => value + $t(' m²')"
                  :value="[filter.surfaceGt, filter.surfaceLt]"
                  @input="
                      values =>
                        addFilter({
                          surfaceGt: values[0],
                          surfaceLt: values[1]
                        })
                    "
              ></ubi-slider>
            </el-form-item>
          </el-col>
          <el-col :lg="4">
            <!-- Price minimum field -->
            <el-form-item no-help :label="$t('general.filters.priceMin')">
              <el-input
                  type="number"
                  :value="filter.priceGt"
                  @input="priceGt => addFilter({ priceGt })"
                  :placeholder="$t('')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="4">
            <!-- Price maximum field -->
            <el-form-item no-help :label="$t('general.filters.priceMax')">
              <el-input
                  type="number"
                  :value="filter.priceLt"
                  @input="priceLt => addFilter({ priceLt })"
                  :placeholder="$t('')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" v-if="isMainAccount || isSubAdmin">
            <el-form-item :label="$t('posts.edit.user')">
              <el-select
                  v-model="filter.user"
                  clearable
                  filterable
                  reserve-keyword
              >
                <el-option
                    style="text-transform:capitalize"
                    v-for="filterUser in users"
                    :key="filterUser.id"
                    :value="filterUser.id"
                    :label="filterUser.fullname + ' - ' + filterUser.username"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :class="(isMainAccount || isSubAdmin) ? 'listContacts' : ''">
            <el-tooltip placement="top-start" :content="$t('general.filters.tooltipContactList')" style="float: right; margin-right: 220px; margin-top: 3px">
              <em class="el-icon-question"></em>
            </el-tooltip>
            <el-form-item :label="$t('users.contact')" >
              <el-select
                  class="filter-modified"
                  v-model="filter.contact"
                  clearable
                  filterable
                  reserve-keyword
              >
                <el-option
                    style="text-transform:capitalize"
                    v-for="filterContact in contacts"
                    v-if="filterContact.fullname"
                    :key="filterContact.id"
                    :value="filterContact.fullname"
                    :label="filterContact.fullname"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="background-color: #ebf3f2;">
          <el-col :lg="12">
            <el-form-item>
              <el-radio-group
                  :value="filter.annoncesDiffusees"
                  @input="annoncesDiffusees => addFilter({ annoncesDiffusees })">
                <el-radio value="O" label="O">{{ libelleAnnoncesDiffusees }}</el-radio>
                <el-radio value="N" label="N">{{ libelleAnnoncesNonDiffusees }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </ubi-search-container>
  </ubi-panel>
</template>

<script>

import { mapGetters, mapMutations, mapState } from 'vuex'
import PostFilterObjectType from '../../components/PostFilterObjectTypeSearchImmo.vue'
import { getUsers } from '@/services/users'

export default {
  name: 'SearchImmoDefault',
  props: ['filters', 'marqueVehicule', 'modeleVehicule'],
  components: {
    PostFilterObjectType
  },
  data () {
    return {
      users: '',
      contacts: '',
      libelleAnnoncesDiffusees: this.$t('general.filters.diffusedAds'),
      libelleAnnoncesNonDiffusees: this.$t('general.filters.noDiffusedAds')
    }
  },
  computed: {
    ...mapState('postsListImmo', ['filter', 'results', 'fetchModeles']),
    ...mapGetters([
      'hasMultiAccounts',
      'isMainAccount',
      'isSubAdmin',
      'isSubUser',
      'getOfferTypes',
      'getPickerOptionsShortcuts',
      'nbStocks',
      'isBailleurSocial',
      'isPromoteur',
      'isCmi',
      'stocks',
      'getSitimmoUser'
    ]),
    ...mapGetters('lamotte', ['getAdvertisers']),
    userFilter () {
      return this.filter.user
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    }
  },
  methods: {
    ...mapMutations('postsListImmo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'setFilterAdvanced',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter',
      'setObjectType',
      'setAnnonceParente',
      'SET_FETCH_MODELES',
      'SET_LOADING_STATUS'
    ]),
    async doFilter (type) {
      if (this.fetchModeles) {
        type = 'modeles'
      }
      if (this.$store.state.postsListImmo.loadingStatus) {
        console.log('Loading in progress, skipping')
        this.SET_LOADING_STATUS(false)
        return
      }

      const updatedFilter = {
        ...this.filter,
        page: 1,
        annoncesActivees: null,
        annoncesDesactivees: null,
        annoncesModeles: null,
        annoncesSupprimees: null,
        withoutPictures: null,
        annoncesVendues: null
      }

      switch (type) {
        case 'reset':
          this.resetFilter()
          updatedFilter.search = ''
          updatedFilter.typeObjets = null
          updatedFilter.dateCreationGt = null
          updatedFilter.dateCreationLt = null
          updatedFilter.surfaceGt = null
          updatedFilter.surfaceLt = null
          updatedFilter.objectTypes = []
          updatedFilter.offerTypes = null
          updatedFilter.mandates = null
          updatedFilter.priceLt = null
          updatedFilter.priceGt = 0
          type = 'enable'
          this.$ga.event('annonce', 'clic', 'retour_liste_prog_prom', this.getSitimmoUser.id)
          this.setAnnonceParente(null)
          if (this.isCmi) {
            updatedFilter.annoncesModeles = false
          }
          break
        case 'enable':
          updatedFilter.annoncesActivees = true
          break
        case 'resetFromSearch':
          updatedFilter.search = ''
          updatedFilter.typeObjets = null
          updatedFilter.dateCreationGt = null
          updatedFilter.dateCreationLt = null
          updatedFilter.surfaceGt = null
          updatedFilter.surfaceLt = null
          updatedFilter.objectTypes = []
          updatedFilter.offerTypes = null
          updatedFilter.mandates = null
          updatedFilter.priceLt = null
          updatedFilter.priceGt = 0
          type = 'enable'
          break
        case 'archived':
          this.setFilter({
            dateCreationLt: this.$moment()
              .subtract(6, 'months')
              .toDate()
          })
          break
        case 'disabled':
          updatedFilter.annoncesDesactivees = true
          updatedFilter.annoncesActivees = false
          break
        case 'modeles':
          updatedFilter.annoncesDesactivees = false
          updatedFilter.annoncesActivees = false
          updatedFilter.annoncesModeles = true
          break
        case 'withoutPictures':
          updatedFilter.withoutPictures = true
          break
        case 'deleted':
          updatedFilter.annoncesSupprimees = true
          break
        case 'sold':
          updatedFilter.annoncesVendues = true
          break
      }

      await this.$store.commit('postsListImmo/setFilter', {
        ...updatedFilter,
        preset: type
      })

      await this.$store.dispatch('postsListImmo/loadPosts')
      // this.$emit('find-contacts')
      this.SET_FETCH_MODELES(false)
    },
    upperCase (string) {
      if (!string) return ''
      return string.charAt(0).toUpperCase() + string.substr(1)
    },
    libellesAnnoncesDiffusees () {
      if (this.getAdvertisers.includes(this.getSitimmoUser.id)) {
        this.libelleAnnoncesDiffusees = this.$t('general.filters.annoncesValides')
        this.libelleAnnoncesNonDiffusees = this.$t('general.filters.annoncesNonValides')
      }
    }
  },
  async beforeMount () {
    if (this.hasMultiAccounts) {
      this.users = (await getUsers({ active: true, pagination: false, roles: '!ROLE_CONTACT' })).list
    }
    const contacts = await getUsers({ active: true, pagination: false })
    if (contacts) {
      this.contacts = contacts.list
    }
    this.libellesAnnoncesDiffusees()
  }
}
</script>

<style lang="css" scoped>
  .listContacts { margin-left: -33.3% }
</style>
